import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IReminderGroup } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'upsert-calendar-modal',
  templateUrl: './upsert-calendar-modal.component.html',
  styleUrls: ['./upsert-calendar-modal.component.scss']
})
export class UpsertCalendarModalComponent implements OnInit {

  public group: IReminderGroup;
  public currentUserEmail: string;

  constructor(public modal: NgbActiveModal) {
  }

  ngOnInit() {
    if (!this.group) {
      this.group = {
        title: '',
        recipientEmails: [this.currentUserEmail],
        daysToNotice: 2
      };
    }
  }
}
